import React from "react"
import styles from "./infoText.module.css"

const InfoText = ({ children }) => {
    return (
        <p className={styles.infoText}>
            {children}
        </p>
    )
}

export default InfoText